// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202611040736/js/" + chunkId + "." + {"44":"2a5b1e0f","225":"8ff3afd6","481":"a19f48e6","486":"20c7e1b9","770":"e3432d49"}[chunkId] + ".0.29381156568332545.chunk.js";
};